import React from 'react';
import { Dropdown, IDropdownOption } from '@fluentui/react';
import { Trans } from 'react-i18next';
import './SortFilter.scss';

interface ISortFilterProps {
    selectedKey: string;
    onChange: (key: string) => void;
    options?: IDropdownOption[];
}

const defaultSortOptions: IDropdownOption[] = [
    { key: 'Relevance', text: 'Relevance' },
    { key: 'Newest', text: 'Newest First' },
    { key: 'Oldest', text: 'Oldest First' }
];

export const getOrderBy = (sort: string): string[] => {
    switch (sort) {
        case 'Newest': return ['CreatedOn desc'];
        case 'Oldest': return ['CreatedOn'];
        default: return [];
    }
};

const dropdownStyles = {
    dropdown: { border: 'none', selectors: { ':focus::after': { border: 'none' }, ':hover .ms-Dropdown-title': { border: 'none' } } },
    title: { border: 'none', background: 'transparent' },
    caretDownWrapper: { color: '#0078d4' },
    caretDown: { color: '#0078d4', fontSize: '10px', fontWeight: '600' as any }
};

export const SortFilter: React.FC<ISortFilterProps> = ({ selectedKey, onChange, options }) => {
    const sortOptions = options || defaultSortOptions;

    return (
        <div className="filter-cont sort-filter-cont">
            <span className="filter-heading"><Trans>Sort by</Trans></span>
            <Dropdown
                aria-label="Sort by"
                selectedKey={selectedKey}
                options={sortOptions}
                onChange={(_, option) => {
                    if (option) {
                        onChange(option.key as string);
                    }
                }}
                className="sort-dropdown"
                styles={dropdownStyles}
            />
        </div>
    );
};
